// extracted by mini-css-extract-plugin
export var logo = "_4m-2";
export var logoWrapper = "_4m-1";
export var strip = "_4m-0";